import * as XLSX from 'xlsx';

export const exportToExcel = (data, filename) => {
    const ws = XLSX.utils.json_to_sheet(data, { skipHeader: false });
  
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  
    XLSX.writeFile(wb, `${filename}.xlsx`, {
      bookType: 'xlsx',
      type: 'binary',
      Props: {
        Title: filename,
        Author: 'Export Script',
      }
    });
  };

export const exportToCSV = (data, filename) => {
    const ws = XLSX.utils.json_to_sheet(data);
    const csv = XLSX.utils.sheet_to_csv(ws);

    // Convert the CSV string to a Blob
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });

    // Create a download link
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);

    // Set the download attribute and file name
    link.download = `${filename}.csv`;

    // Append the link to the document and trigger the download
    document.body.appendChild(link);
    link.click();

    // Remove the link from the document
    document.body.removeChild(link);
};
